import { ChangeDetectorRef } from '@angular/core';

/**
 * Self-contained auto-hiding toast state.
 *
 * Handles the show -> auto-hide-after-ttl choreography (and re-triggering the
 * enter animation when shown again while already visible) so callers don't have
 * to duplicate timer bookkeeping per toast.
 */
export class AutoHideToast {
  visible = false;
  fileName = '';

  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly ttlMs = 6000,
  ) {}

  show(fileName = ''): void {
    this.clearTimer();
    this.fileName = fileName;

    if (this.visible) {
      // Toggle off in this tick so the enter animation replays on re-show.
      this.visible = false;
      this.cdr.detectChanges();
      setTimeout(() => this.activate());
      return;
    }

    this.activate();
  }

  hide(): void {
    this.clearTimer();
    this.visible = false;
    this.cdr.detectChanges();
  }

  /** Clears any pending timer without touching visibility (use on destroy). */
  dispose(): void {
    this.clearTimer();
  }

  private activate(): void {
    this.visible = true;
    this.cdr.detectChanges();
    this.timer = setTimeout(() => {
      this.visible = false;
      this.cdr.detectChanges();
    }, this.ttlMs);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
